import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=7cb2baa2&scoped=true&"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&id=7cb2baa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb2baa2",
  null
  
)

export default component.exports